
import axios from 'axios';
import config from '@/config';

const { iffApi } = config.ctx;

export const kTableListService = {
  // 查询
  query: (params) => { return axios.get(`${iffApi}/examples/list`, { params: params }); },

  // 查看
  getDetail: (id) => { return axios.get(`${iffApi}/examples/${id}`); },

  // 新增
  save: (fd) => { return axios.post(`${iffApi}/examples`, fd); },

  // 修改
  update: (id, fd) => { return axios.put(`${iffApi}/examples/${id}`, fd); },

  // 删除
  delete: (id) => { return axios.delete(`${iffApi}/examples/${id}`); },

  // 导出
  export: (params) => { return axios.get(`${iffApi}/examples/export`, { responseType: 'blob', params }); }
};
